import { useEffect, useState } from "react";
import { Check, Download } from "lucide-react";
import { IosInstallSteps } from "@/components/IosInstallSteps";
import { getDeferredInstallPrompt, isIosSafari, subscribeInstallPrompt } from "@/lib/device";

/** Инструкция «Добавь TurkeyDrive на экран «Домой»» с пунктами «зачем». Пока не подключена — пригодится для напоминаний. */
export function InstallGuide({
  platform,
  onInstalled,
}: {
  platform: "ios" | "android" | "desktop";
  onInstalled: () => void;
}) {
  const [, force] = useState(0);
  useEffect(() => subscribeInstallPrompt(() => force((x) => x + 1)), []);
  const deferred = getDeferredInstallPrompt();

  const install = async () => {
    if (!deferred) return;
    await deferred.prompt();
    const choice = await deferred.userChoice.catch(() => null);
    if (choice?.outcome === "accepted") onInstalled();
  };

  let body: React.ReactNode;
  if (platform === "ios") {
    body = isIosSafari() ? (
      <IosInstallSteps />
    ) : (
      <p className="text-base text-td-dark">
        Открой <b>turkey-drive.com</b> в Safari — установить приложение на iPhone можно только
        оттуда.
      </p>
    );
  } else if (platform === "android" && deferred) {
    body = (
      <button
        type="button"
        onClick={install}
        className="cta-solid flex min-h-12 w-full items-center justify-center gap-2 rounded-full px-4 py-3 text-base font-semibold"
      >
        <Download className="size-4" /> Установить
      </button>
    );
  } else if (platform === "android") {
    body = (
      <p className="text-base text-td-dark">Открой меню ⋮ в браузере → «Установить приложение».</p>
    );
  } else {
    body = (
      <p className="text-base text-td-dark">
        Открой <b>turkey-drive.com</b> на телефоне — и установи приложение оттуда.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="font-display text-2xl font-bold text-td-dark">
        Добавь TurkeyDrive на экран «Домой»
      </h1>
      {platform !== "ios" && (
        <ul className="space-y-2 text-sm text-td-dark">
          {[
            "Придёт ответ на твоё приглашение на кофе",
            "Узнаешь о встречах по твоим интересам",
            "Открывается в один тап, как обычное приложение",
          ].map((t) => (
            <li key={t} className="flex items-start gap-2">
              <Check className="mt-0.5 size-4 shrink-0 text-td-teal" /> {t}
            </li>
          ))}
        </ul>
      )}
      {body}
    </div>
  );
}
